import SharingComponent from "./sharingComponent";

import { createSharingUrls } from "./../utilities/utils";

import { OPENED_SHARE_MENU_ALB } from "./../analytics/analyticsevents";

export default class SharingController {
  appState;
  albSlide;
  options;
  DOMContainer;

  constructor(
    appState,
    albSlide,
    DOMContainer,
    options = {},
    showSharing = true
  ) {
    this.appState = appState;
    this.albSlide = albSlide;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this._showSharing = showSharing;
    this.init();
  }

  close(e, force) {
    return this.shareComponent.close(e, force);
  }

  init() {
    let url = this.createUrl();
    let links = null;
    if (this._showSharing) {
      if (url) {
        links = createSharingUrls(
          url,
          {
            title: this.albSlide.getTitle(),
            intro: this.albSlide.getIntro(),
          },
          this.options.sharingOptions,
          this.appState.isDesktop
        );
      }
    }
    this.shareComponent = new SharingComponent(
      this.appState,
      links,
      this.DOMContainer,
      this.options,
      OPENED_SHARE_MENU_ALB
    );
    this.DOMContainer.classList.remove("hidden");
  }

  createUrl() {
    let url = null;
    if (this.options.shareFromReader) {
      url = this.appState._sharingUrl;
      if (url) {
        url = url.replace(/\{0\}/g, this.appState.contentPackageId);
        url = url.replace(/\{1\}/g, this.appState.publicationId);
        url = url.replace(/\{2\}/g, this.appState.currentPage + 1);
        url = url.replace(/\{3\}/g, this.appState.contentid);
        const intro = this.albSlide.getIntro();
        const title = this.albSlide.getTitle();
        if (intro) {
          url = url.replace(/\{4\}/g, encodeURIComponent(intro));
        } else {
          url = url.replace(/\{4\}/g, encodeURIComponent(title));
        }
        url = url.replace(/\{5\}/g, encodeURIComponent(title));
        url = url.replace(/\{6\}/g, this.albSlide.content.PublicationPageID);
        url = url.replace(/\{7\}/g, Date.now());
        url = url.replace(
          /\{8\}/g,
          this.albSlide.content.ExternalContentReference
        );
        url = url.replace(
          /\{9\}/g,
          this.appState.contentPackage.bundleDateTime
        );
        url = url.replace(/\{10\}/g, this.appState.downloadToken);
      }
    } else {
      url = this.albSlide.getSharingLink();
    }
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/sharingController.js